import { useMutation } from '@tanstack/react-query'
import { errorMessage } from 'lib/flash-message'
import { InfoButton } from 'components/buttons'
import { track, useTracking } from 'lib/analytics'
import { cloneTemplate } from '../../../api'

export interface CloneButtonProps {
  ctaText: string
  destinationRegistryId: number
  registryTemplateTitle: string
  registryTemplateType: string
  sourceTemplateId: string
  onSubmitSuccess: () => void
}

export const CloneButton = ({
  ctaText,
  destinationRegistryId,
  registryTemplateTitle,
  registryTemplateType,
  sourceTemplateId,
  onSubmitSuccess,
}: CloneButtonProps) => {
  const tracker = useTracking()
  const { mutate: clone, isLoading: isSubmitting } = useMutation({
    mutationFn: () => cloneTemplate(sourceTemplateId, destinationRegistryId),
    onSuccess: () => {
      onSubmitSuccess()
    },
    onError: () => {
      errorMessage('Unable to copy these items')
    },
  })

  const handleSubmit = () => {
    tracker.trackEvent({
      event: track.registryTemplateCopied,
      eventLocation: track.EventLocation.REGISTRY_PREVIEW_PAGE,
      registryTemplateId: parseInt(sourceTemplateId),
      registryTemplateTitle,
      registryTemplateType,
    })
    // Call Clone Template API
    clone()
  }
  return (
    <InfoButton
      pill
      disabled={isSubmitting}
      style={{ minWidth: 315 }}
      submitting={isSubmitting}
      onClick={handleSubmit}
    >
      {ctaText}
    </InfoButton>
  )
}
